import { Box } from "../../Box";
import { Text } from "../../Text";
import { CopyableValue } from "../CopyableValue";
import { Field } from "./shared";

export function CopyableField({
  label,
  hint,
  value,
}: {
  label: string;
  hint: string;
  value: string;
}) {
  return (
    <Field>
      <Box horizontal={8} vertical={10}>
        <Text variant="text-small-md">{label}</Text>
      </Box>
      <CopyableValue value={value}>
        <Text
          variant="text-regular"
          color="var(--text-secondary)"
          style={{ flex: 1 }}
        >
          {value}
        </Text>
      </CopyableValue>
      <Box horizontal={8} top={6}>
        <Text variant="text-small" color="var(--text-secondary)">
          {hint}
        </Text>
      </Box>
    </Field>
  );
}
